import React from 'react'
import Day1 from './Day.jpg'
const Package = () => {
  return (
    <div>
      <div className='mt-14 mx-auto px-4 bg-litegreen rounded-2xl drop-shadow-xl py-8
      md:flex md:w-[90%]
      xl:w-5/6'>
        <div className='mx-2
        md:w-[40%]'>
          <img src={Day1} className='rounded-2xl
          md:w-full md:h-full md:object-cover' alt='Day1'/>
        </div>
        <div className='w-5/6 mx-auto
        md:w-1/2'>
          <h1 className='text-center mx-2 font-bold text-xl
          sm:text-2xl md:text-xl
          xl:text-3xl'>Day 1: Welcome</h1>
          <ul className='list-disc text-[1.08rem] mt-2 ml-2
          sm:text-[1.35rem] md:text-[1.08rem]
          xl:text-[1.45rem] xl:mt-6 '>
            <li> in Traditional Indian Manner </li>
            <li> Refreshments </li>
            <li> 3:30 PM: Welcome kit and Retreat Orientation, introduction and Demonstrations of Retreat by Yoga Guru. </li>
            <li> 5:00 PM Ganga Aarti at Triveni Ghat </li>
            <li> 8:00pm Dinner at Ayushman Retreat </li>
            <li> 10pm Lights out </li>
          </ul>
        </div>
      </div>

      <div className='mt-14 mx-auto px-4 bg-litegreen rounded-2xl drop-shadow-xl py-8
      md:flex md:flex-row-reverse md:w-[90%]
      xl:w-5/6'>
        <div className='mx-2
        md:w-[40%]'>
          <img src={Day1} className='rounded-2xl
          md:w-full md:h-full md:object-cover' alt='Day1'/>
        </div>
        <div className='w-5/6 mx-auto
        md:w-1/2'>
          <h1 className='text-center mx-2 font-bold text-xl
          sm:text-2xl md:text-xl
          xl:text-3xl'>Day 2: introduction</h1>
          <ul className='list-disc text-[1.08rem] mt-2 ml-2
          sm:text-[1.35rem] md:text-[1.08rem]
          xl:text-[1.45rem] xl:mt-6 '>
            <li> in Traditional Indian Manner </li>
            <li> Refreshments </li>
            <li> 3:30 PM: Welcome kit and Retreat Orientation, introduction and Demonstrations of Retreat by Yoga Guru. </li>
            <li> 5:00 PM Ganga Aarti at Triveni Ghat </li>
            <li> 8:00pm Dinner at Ayushman Retreat </li>
            <li> 10pm Lights out </li>
          </ul>
        </div>
      </div>


      <div className='mt-14 mx-auto px-4 bg-litegreen rounded-2xl drop-shadow-xl py-8
      md:flex md:w-[90%]
      xl:w-5/6'>
        <div className='mx-2
        md:w-[40%]'>
          <img src={Day1} className='rounded-2xl
          md:w-full md:h-full md:object-cover' alt='Day1'/>
        </div>
        <div className='w-5/6 mx-auto
        md:w-1/2'>
          <h1 className='text-center mx-2 font-bold text-xl
          sm:text-2xl md:text-xl
          xl:text-3xl'>Day 3: A Walk to Remember</h1>
          <ul className='list-disc text-[1.08rem] mt-2 ml-2
          sm:text-[1.35rem] md:text-[1.08rem]
          xl:text-[1.45rem] xl:mt-6 '>
            <li> in Traditional Indian Manner </li>
            <li> Refreshments </li>
            <li> 3:30 PM: Welcome kit and Retreat Orientation, introduction and Demonstrations of Retreat by Yoga Guru. </li>
            <li> 5:00 PM Ganga Aarti at Triveni Ghat </li>
            <li> 8:00pm Dinner at Ayushman Retreat </li>
            <li> 10pm Lights out </li>
          </ul>
        </div>
      </div>


      <div className='mt-14 mx-auto px-4 bg-litegreen rounded-2xl drop-shadow-xl py-8
      md:flex md:flex-row-reverse md:w-[90%]
      xl:w-5/6'>
        <div className='mx-2
        md:w-[40%]'>
          <img src={Day1} className='rounded-2xl
          md:w-full md:h-full md:object-cover' alt='Day1'/>
        </div>
        <div className='w-5/6 mx-auto
        md:w-1/2'>
          <h1 className='text-center mx-2 font-bold text-xl
          sm:text-2xl md:text-xl
          xl:text-3xl'>Day 1: Welcome</h1>
          <ul className='list-disc text-[1.08rem] mt-2 ml-2
          sm:text-[1.35rem] md:text-[1.08rem]
          xl:text-[1.45rem] xl:mt-6 '>
            <li> in Traditional Indian Manner </li>
            <li> Refreshments </li>
            <li> 3:30 PM: Welcome kit and Retreat Orientation, introduction and Demonstrations of Retreat by Yoga Guru. </li>
            <li> 5:00 PM Ganga Aarti at Triveni Ghat </li>
            <li> 8:00pm Dinner at Ayushman Retreat </li>
            <li> 10pm Lights out </li>
          </ul>
        </div>
      </div>

    </div>
  )
}

export default Package
